import { gql } from '@apollo/client';

export const CLAIM_ADJUSTMENT_FIELDS = gql`
    fragment ClaimAdjustmentFields on claim_adjustments {
        claim_adjustment_id
        claim_id
        type
        amount
        invoice_timestamp
        invoice_id
    }
`;
